import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useCustomerSupportView = () => {
  const location = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const requestId = searchParams.get('requestId');
    return {
      urlRequestId: requestId,
      isCustomerSupportView: Boolean(requestId),
    };
  }, [location.search]);
};

export default useCustomerSupportView;
